/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_Other_PlaceholderInputs */

const en_us2_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A podcast, a running group…`)
};

const pt_br2_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um podcast, um grupo de corrida…`)
};

const es_419_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un podcast, un grupo de corredores…`)
};

const pt_pt2_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um podcast, um grupo de corrida…`)
};

const fr_fr2_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un podcast, un club de course…`)
};

const de_de2_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Podcast, ein Lauftreff…`)
};

const it_it2_onboarding_how_heard_other_placeholder = /** @type {(inputs: Onboarding_How_Heard_Other_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un podcast, un gruppo di corsa…`)
};

/**
* | output |
* | --- |
* | "A podcast, a running group…" |
*
* @param {Onboarding_How_Heard_Other_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_other_placeholder = /** @type {((inputs?: Onboarding_How_Heard_Other_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_Other_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_other_placeholder(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_other_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_other_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_other_placeholder(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_other_placeholder(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_other_placeholder(inputs)
	return en_us2_onboarding_how_heard_other_placeholder(inputs)
});
export { onboarding_how_heard_other_placeholder as "onboarding.how_heard.other_placeholder" }